'use client';
import { config } from '@/configs/configPortal';
import { MODELS_BIKE_MOST_VIEWED, MODELS_CAR_MOST_VIEWED, TEXT_TYPE_VEHICLE } from '@/helpers/constants';
import { formatToSlug, isVehicleType } from '@/helpers/utils';
import { useGeneralStore } from '@/providers/general-store-provider';
import Image from 'next/image';
import Link from 'next/link';
import { useMemo } from 'react';
import './model.scss';

export default function Models() {
    const currentUrl = config.urlTableFipe
    const webmotorsUrl = config.urlWebApp

    const { vehicleType } = useGeneralStore()

    const isBike = useMemo(() => isVehicleType(vehicleType, 'bike'), [vehicleType])

    const modelList = useMemo(() => isBike ? MODELS_BIKE_MOST_VIEWED : MODELS_CAR_MOST_VIEWED, [isBike]);

    function getTypeVehicleText() {
        return isBike ? TEXT_TYPE_VEHICLE.bikes : TEXT_TYPE_VEHICLE.cars
    }

    return (
        <div id="home-models-container" className="home-models-container" data-testid="home-models-container">
            <div id="grid-models" className="grid-models" data-testid="grid-models">
                {modelList?.map((model, index) => (
                    <Link
                        href={`${currentUrl}/${getTypeVehicleText()}/${formatToSlug(model.makeName)}/${formatToSlug(model.modelName)}`}
                        id={`model-link-${index}`}
                        data-testid={`model-link-${index}`}
                        key={`model-link-${index}`}
                        legacyBehavior
                    >
                        <div
                            key={model.modelName}
                            id={`grid-models-container-${index}`}
                            className="grid-models-container"
                            data-testid={`grid-models-container-${index}`}
                        >
                            <div
                                id={`model-image-container-${index}`}
                                className="model-image"
                                data-testid={`model-image-container-${index}`}
                            >
                                <Image
                                    src={
                                        isBike
                                            ? `${process.env.NEXT_PUBLIC_ASSETS_PATH}/assets/img/bike-default.svg`
                                            : model.versionLinkImage
                                                ? `${webmotorsUrl}imagens/prod${model.versionLinkImage}.webp?s=fill&w=136&h=100&q=70&t=true`
                                                : `${process.env.NEXT_PUBLIC_ASSETS_PATH}/assets/img/car_default.svg`
                                    }
                                    alt={`Marca ${model.makeName}`}
                                    title={`Modelo ${model.modelName}`}
                                    width="136"
                                    height="100"
                                    data-testid={`model-image-${index}`}
                                    loading="lazy"
                                    id={`model-image-${index}`}
                                />
                            </div>
                            <div
                                id={`model-info-${index}`}
                                className="model-info"
                                data-testid={`model-info-${index}`}
                            >
                                <Link href={`${currentUrl}/${getTypeVehicleText()}/${formatToSlug(model.makeName)}/${formatToSlug(model.modelName)}`}
                                    id={`model-title-${index}`}
                                    className='model-title'
                                    data-testid={`model-title-${index}`}>
                                    {model.makeName} <strong>{model.modelName}</strong>
                                </Link>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    )
}
